export const REPORTSTATUS = {
  NEW: 'NEW',
  EDITING: 'EDITING',
  ONGOING: 'ONGOING',
  CONFIRMED: 'CONFIRMED',
  CLOSED: 'CLOSED',
  CORRECTED: 'CORRECTED',
  BILLED: 'BILLED',
  REBILLED: 'REBILLED',
  REOPENED: 'REOPENED'
};

export const INVOICING_LIMIT = {
  OVER: 'OVER',
  UNDER: 'UNDER'
};

export interface IStore {
  settings?: ISettings;
  backendversion?: string;
  serverTime?: string;
  user?: IUserProfile;
  companies?: ICompany[];
  users?: IUserProfile[];
  privacyStatement?: IPrivacyStatement[];
  categories?: IPomReportCategoryData[];
  messages?: IMailTemplateDetails;
  infotexts?: IInfoTextDetails;
}

export interface IIdTokenClaims {
  roles?: string[];
  name?: string;
  email?: string;
}

export interface IRouteConfigData {
  path: string;
  renderBreadcrumb: (state?: any) => JSX.Element;
}

export interface IRouteConfig {
  [x: string]: IRouteConfigData;
}

export interface ISettings {
  billing_limit: string;
  accounting_email: string;
}

export interface IToast {
  type: string;
  id?: string;
  title: string;
  content: string;
  info?: string;
  timestamp?: string;
}

export interface IMailTemplateDetails {
  message_id: string;
  title_fi: string;
  title_fi_class?: string;
  title_se: string;
  title_se_class?: string;
  title_en: string;
  title_en_class?: string;
  text_fi: string;
  text_fi_class?: string;
  text_se: string;
  text_se_class?: string;
  text_en: string;
  text_en_class?: string;
}

export interface IInfoTextDetails {
  text_id: string;
  text_fi: string;
  text_se: string;
  text_en: string;
}

export interface IUserCompanies {
  id: string;
  name: string;
}

export interface IUserProfile {
  user_id?: number;
  user_name: string;
  name: string;
  role?: string;
  language: string;
  archived: boolean;
  phone: string;
  reporter: boolean;
  information: boolean;
  companies: IUserCompanies[];
  selected_comp?: IUserCompanies;
}

export interface IUserSettings {
  user_id?: number;
  user_name: string;
  name: string;
  // role?: string;
  language: string;
  archived: boolean;
  phone: string;
  reporter: boolean;
  information: boolean;
  companies: number[];
}

export interface IPrivacyStatement {
  row_number: string;
  header_fi: string;
  header_se: string;
  header_en: string;
  text_fi: string;
  text_se: string;
  text_en: string;
  modified: string;
  created: string;
}

export interface IEventLogRow {
  timestamp?: string;
  type: string;
  event: string;
  user_name: string;
  company: string;
  info: string;
}

export interface IPomReportCategoryData {
  code: string;
  code_class?: string;
  view_code: string;
  name_fi: string;
  name_fi_class?: string;
  name_en: string;
  name_en_class?: string;
  name_se: string;
  name_se_class?: string;
  mod?: boolean;
  subs: IPomReportSubCategoryData[];
  active?: boolean;
}

export interface IPomReportSubCategoryData {
  code: string;
  category?: string;
  category_title?: string | JSX.Element | JSX.Element[];
  view_code: string;
  name_fi: string;
  name_en: string;
  name_se: string;
  unit: string;
  description_fi: string;
  description_en: string;
  description_se: string;
  price: any;
  fin: boolean;
  aland: boolean;
  b2b: boolean;
}

export interface IPomReportSummaryInfo {
  company: string;
  total_eur: number;
  status: string;
  reports: IPomReportDataInfo[];
}

export interface IPomReportDataInfo {
  report_id: string;
  period: string;
  user_name: string;
  name: string;
  company: string;
  total_fin_eur: number;
  total_fin_pcs: number;
  total_fin_kg: number;
  total_aland_eur: number;
  total_aland_pcs: number;
  total_aland_kg: number;
  total_b2b_eur: number;
  total_b2b_pcs: number;
  total_b2b_kg: number;
  total_eur: number;
  total_pcs: number;
  total_kg: number;
  reference: string;
  status: string;
  modified: string;
  created: string;
  reminder: string;
  report_interval: string;
}

export interface IPomReportDataCategory {
  [x: string]: IPomReportDataSubCategory[];
}

export interface IPomReportDataSubCategory {
  [x: string]: IPomReportDataSubCategoryDetails;
}

export interface IPomReportDataSubCategoryDetails {
  amount_fin: number;
  amount_aland: number;
  amount_b2b: number;
  eur_fin: number;
  eur_aland: number;
  eur_b2b: number;
  modified_fin?: number;
  modified_aland?: number;
  modified_b2b?: number;
}

export interface IPomReportDataCategoryPeriod {
  [x: string]: IPomReportDataSubCategoryDetailsPeriod[];
}

export interface IPomReportDataSubCategoryDetailsPeriod {
  code: string;
  period: string;
  amount_fin: number;
  amount_aland: number;
  amount_b2b: number;
  eur_fin: number;
  eur_aland: number;
  eur_b2b: number;
  modified_fin?: number;
  modified_aland?: number;
  modified_b2b?: number;
}

export interface IPomReportCategorySumItem {
  report_id: string;
  category: string;
  total_fin_eur: number;
  total_fin_kg: number;
  total_fin_pcs: number;
  total_aland_eur: number;
  total_aland_kg: number;
  total_aland_pcs: number;
  total_b2b_eur: number;
  total_b2b_kg: number;
  total_b2b_pcs: number;
  total_eur: number;
  total_kg: number;
  total_pcs: number;
}

export interface IPomReportTotalSumItem {
  report_id: string;
  total_fin_eur: number;
  total_fin_kg: number;
  total_fin_pcs: number;
  total_aland_eur: number;
  total_aland_kg: number;
  total_aland_pcs: number;
  total_b2b_eur: number;
  total_b2b_kg: number;
  total_b2b_pcs: number;
  total_eur: number;
  total_kg: number;
  total_pcs: number;
}

export interface IPomReportResultData {
  info: IPomReportResultDataInfo;
  inputs: IPomReportResultCategoryData[];
  totals: IPomReportTotalSumItem;
}

export interface IPomReportResultDataInfo {
  user_name: string;
  company_id: string;
  reference: string;
  status: string
}

export interface IPomReportResultCategoryData {
    code: string;
    name: string;
    subs: IPomReportResultSubData[]
    catSums: IPomReportCategorySumItem
  }

export interface IPomReportResultSubData {
  code: string;
  vievCode: string;
  name: string;
  unit: string;
  inputs: IPomReportAreaData;
}

export interface IPomReportAreaData {
  fi: IPomReportDetails;
  al: IPomReportDetails;
  b2b: IPomReportDetails;
}

export interface IPomReportDetails {
  value: number;
  weight: number;
}

export interface ICompany {
  name: string;
  business_id: string;
  address: string;
  postal_code: string;
  city: string;
  country: string;
  phone: string;
  www: string;
  archived: boolean;
  archive_period: string[];
  id: string;
  member: string;
  member_since: string;
  reporting_started: string;
  reporting_ended: string;
  reporting_interval: string;
  certificate: string;
  users: number[];
}

export interface ICompanyBilling {
  company_id?: string;
  name: string;
  name2: string;
  name3: string;
  address: string;
  postal_code: string;
  city: string;
  country: string;
  reference:  string;
  vat_rate: string;
  payment_term: string;
  type: string;
  email: string;
  einvoice_operator: string;
  einvoice_id: string;
  ledger_query: string;
  period: string;
  lang: string;
}

export interface ICompanyAndBilling extends ICompany {
  billing: ICompanyBilling;
}

export interface IReportedPom {
  company: string;
  name: string;
}

export interface ICategoryPeriod extends IReportedPom {
    period: string;
    total_fin_kg: string;
    total_fin_pcs: string;
    total_aland_kg: string;
    total_aland_pcs: string;
    total_b2b_kg: string;
    total_b2b_pcs: string;
    total_kg: string;
    total_pcs: string;
    fin_kg: number;
    fin_pcs: number;
    aland_kg: number;
    aland_pcs: number;
    b2b_kg: number;
    b2b_pcs: number;
    kg: number;
    pcs: number;
}

export interface ISubcategoryPeriod extends IReportedPom {
  period: string;
  total_fin: string;
  total_aland: string;
  total_b2b: string;
  total: string;
  unit: string;
  fin: number;
  aland: number;
  b2b: number;
  n_total: number;
}

export interface ICategoryReportedPom extends IReportedPom {
  subRows: ICategoryPeriod[];
}

export interface ISubcategoryReportedPom extends IReportedPom {
  subRows: ISubcategoryPeriod[];
}
